import { FC, ChangeEvent } from "react";
import styled from "styled-components";
import css from "@styled-system/css";
import { ColorProps, SpaceProps } from "styled-system";

import Box from "../Box/Box";

interface PaginationProps {
  numberOfPages: number;
  currentPage: number;
  sliderNode: any;
  slidesVisible: number;
  paginationPrimaryColor: ColorProps["backgroundColor"];
  paginationSecondaryColor: ColorProps["backgroundColor"];
  stageRightPadding?: SpaceProps["paddingRight"];
}

const StyledInput = styled.input<{
  numberOfPages: number;
  scrollbarColor: ColorProps["backgroundColor"];
  scrollbarThumbColor: ColorProps["backgroundColor"];
}>`
  width: 100%;
  transform: translateY(50%);
  appearance: none;
  height: 3px;
  outline: none;
  opacity: 0.5;
  -webkit-transition: 0.2s;
  transition: opacity 0.2s;
  border-radius: 20px;
  cursor: pointer;
  margin: 0;
  margin-right: -150px;
  ${(props) =>
    css({
      backgroundColor: props.scrollbarColor as string,
      "::-webkit-slider-thumb": {
        appearance: "none",
        width: `calc(100% / ${props.numberOfPages})`,
        height: "3px",
        backgroundColor: props.scrollbarThumbColor as string,
        cursor: "grab",
        borderRadius: "20px",
      },
      "::-moz-range-thumb": {
        appearance: "none",
        width: `calc(100% / ${props.numberOfPages})`,
        height: "3px",
        backgroundColor: props.scrollbarThumbColor as string,
        cursor: "grab",
        borderRadius: "20px",
      },
    })}
  ::-webkit-slider-thumb:active {
    cursor: grabbing;
  }
`;

const PaginationContainer = styled(Box)`
  :hover,
  :focus {
    > input[type="range"] {
      height: 6px;
      ::-webkit-slider-thumb {
        height: 6px;
      }
    }
  }
`;

const Pagination: FC<PaginationProps> = ({
  numberOfPages,
  currentPage,
  sliderNode,
  slidesVisible,
  paginationPrimaryColor,
  paginationSecondaryColor,
  stageRightPadding,
}) => {
  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    const nextSlide = Number(e.target.value);

    if (sliderNode) {
      sliderNode.slickGoTo(nextSlide * slidesVisible);
    }
  };

  return (
    <PaginationContainer
      className="pagination"
      width="100%"
      height="24px"
      paddingLeft={stageRightPadding}
    >
      <StyledInput
        tabIndex={0}
        numberOfPages={numberOfPages}
        onChange={onChange}
        type="range"
        min={0}
        step={1}
        value={currentPage}
        max={numberOfPages - 1}
        scrollbarColor={paginationSecondaryColor}
        scrollbarThumbColor={paginationPrimaryColor}
      />
    </PaginationContainer>
  );
};

export default Pagination;
